import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const RazonSocialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='RAZON SOCIAL' htmlFor='input-razonSocial' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='razonSocial'>
          {({ field }) => (
            <Form.InputText {...field} id='input-razonSocial' isInvalid={iTouched && iError} disabled={fIsSubmitting} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RazonSocialFormGroup)
